const Parse = global.Parse;
import { TaxonomyName, Taxonomy } from 'domain';

const get = (taxonomyNameId) => {
    const query = new Parse.Query(TaxonomyName)
        .include([
            'taxonomy',
            'taxonomy.primarySystem',
            'taxonomy.subject',
            'taxonomy.reproduction',
            'taxonomy.nativityType',
            'taxonomy.invasiveStatus',
            'taxonomy.securityType',
            'taxonomy.parent',
            'taxonomy.taxonomyType',
            'taxonomy.taxonomyCategory',
            'taxonomy.rinhsStatus',
            'taxonomy.sRank',
            'taxonomy.rigcn',
        ]);

    return {
        type: 'GET_TAXONOMY_NAME',
        meta: { taxonomyNameId },
        payload: query.get(taxonomyNameId)
    };
};


const list = (filters = {}) => {
   const query = new Parse.Query(TaxonomyName)
       .include([
            'taxonomy.primarySystem',
            'taxonomy.subject', 
            'taxonomy.reproduction',
            'taxonomy.nativityType',
            'taxonomy.invasiveStatus',
            'taxonomy.securityType',
       ]);
   
   if (filters.name) {
       query.matches('name', new RegExp(filters.name, 'i'));
   }

   return {
       type: 'LIST_TAXONOMY_NAME',
       meta: { filters },
       payload: query.find()
   };
};

const search = (searchTerm = '', limit = 20, skip = 0) => {
    const query = new Parse.Query(TaxonomyName)
        .include([
            'taxonomy.primarySystem',
            'taxonomy.subject',
        ])
        .limit(limit)
        .skip(skip)
        .ascending('name');
    
    if (searchTerm && searchTerm.trim()) {
        const searchRegex = searchTerm.trim();
        query.matches('name', searchRegex, 'i');
    }

    return {
        type: 'SEARCH_TAXONOMY_NAME',
        meta: { searchTerm, limit, skip },
        payload: query.find()
    };
};

const listSynonyms = (taxonomy) => {
    const query = new Parse.Query(TaxonomyName)
        .equalTo('taxonomy', taxonomy)
        .include([
            'taxonomy.primarySystem',
            'taxonomy.subject', 
            'taxonomy.reproduction',
            'taxonomy.nativityType',
            'taxonomy.invasiveStatus',
            'taxonomy.securityType',
       ]);

    return {
        type: 'LIST_TAXONOMY_NAME',
        meta: { taxonomy },
        payload: query.find()
    };
}

const save = (taxonomyName) => {
    return {
        type: 'SAVE_TAXONOMY_NAME',
        payload: (async () => {
            let nameToSave;
            
            if (taxonomyName.objectId) {
                const query = new Parse.Query('Name');
                nameToSave = await query.get(taxonomyName.objectId);
            } else {
                nameToSave = new TaxonomyName();
            }
            
            nameToSave.set('typeId', taxonomyName.typeId);
            nameToSave.set('name', taxonomyName.name);
            nameToSave.set('taxonomy', { 
                __type: 'Pointer', 
                className: 'Taxonomy', 
                objectId: taxonomyName.taxonomy 
            });

            return nameToSave.save();
        })()
    };
};

const deleteName = (nameId) => {
    return {
        type: 'DELETE_TAXONOMY_NAME',
        payload: (async () => {
            const query = new Parse.Query('Name');
            const nameToDelete = await query.get(nameId);
            await nameToDelete.destroy();
            return { id: nameId };
        })()
    };
};

const deleteNames = (nameIds) => {
    return {
        type: 'DELETE_TAXONOMY_NAMES',
        payload: Promise.all(nameIds.map(async (nameId) => {
            const query = new Parse.Query('Name');
            const nameToDelete = await query.get(nameId);
            await nameToDelete.destroy();
            return nameId;
        }))
    };
};

export default {
   get,
   listSynonyms,
   list,
   search,
   save,
   deleteName,
   deleteNames
};